<script setup></script>

<template>
  <div class="spinner rounded-circle" />
</template>

<style lang="scss" scoped>
@keyframes Rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.spinner {
  width: 18px;
  height: 18px;
  border: 2px solid color-mix(in srgb, var(--wp-chart-cyan) 10%, transparent);
  border-top-color: var(--wp-white);
  animation: Rotate 1.2s linear 0s infinite forwards;
  border-radius: 50%;
}
</style>
